import classNames      from 'classnames'
import React           from 'react'
import { Navbar }      from 'react-bootstrap'
import { Route, Link } from 'react-router-dom'

export NavbarText = ({ id, className, children }) ->
  <p id={id} className={classNames('navbar-text', className)}>{children}</p>

export NavbarHeader = ({ brand }) ->
  <Navbar.Header>
    {<Navbar.Brand>{brand}</Navbar.Brand> if brand}
    <Navbar.Toggle />
  </Navbar.Header>

export NavLink = ({ to, id, className, children, disabled = false }) ->
  link =
    if disabled
      <a id={id} className={className}>{children}</a>
    else
      <Link to={to} id={id} className={className}>{children}</Link>

  li = ({ match }) ->
    <li className={classNames(active: match)}>{link}</li>

  <Route path={to} children={li} />
